import React from "react";
import { Switch } from "react-router-dom";
import PrivateRoute from "src/components/PrivateRoute";

const Dashboard = React.lazy(() => import("src/screens/Dashboard"));
const TermsAndCondition = React.lazy(() => import("src/screens/TermsAndCondition"));
const PrivacyPolicy = React.lazy(() => import("src/screens/PrivacyPolicy"));
const Account = React.lazy(() => import("src/screens/Account"));
const AssistAccountDetails = React.lazy(() => import("src/screens/AssistAccountDetails"));
const NotAuthorized = React.lazy(() => import("src/screens/NotAuthorized"));
const Events = React.lazy(() => import("src/screens/Events"));

const Authenticated: React.FC = () => {
  return (
    <Switch>
      <PrivateRoute path="/dashboard">
        <Dashboard />
      </PrivateRoute>
      <PrivateRoute path="/termsandcondition">
        <TermsAndCondition />
      </PrivateRoute>
      <PrivateRoute path="/privacypolicy">
        <PrivacyPolicy />
      </PrivateRoute>
      <PrivateRoute path="/account">
        <Account />
      </PrivateRoute>
      <PrivateRoute path="/assist-account-details">
        <AssistAccountDetails />
      </PrivateRoute>
      <PrivateRoute path="/notauthorized">
        <NotAuthorized />
      </PrivateRoute>
      <PrivateRoute path="/events">
        <Events />
      </PrivateRoute>
    </Switch>
  );
};

export default Authenticated;
